import {UserTasks} from './userTasks';
import {TakePayment} from "./takePayment";
import {OrgSetting} from "./orgSetting";

export class User {
  _id: string;
  uuid: string;
  orgUuid: string;
  username: string;
  employeeId: string;
  email: string;
  password: string;
  firstName: string;
  excludedCategories: string[];
  firstLogin: boolean;
  takePayment: TakePayment;
  preferredTheme: string;
  assignedTables:string[];
  lastName: string;
  token: string;
  merchantId: string;
  position: {x: number, y: number};
  accountActive: boolean;
  hasCreds: boolean;
  receiptView: boolean;
  orgSettings: OrgSetting;
  role: string[];
  selectedRole: string;
  //square
  locationId: string;
  organization: string;
  uniqueOrgIdent: string;
  phoneNumber: number;

  //to disable dashboard
  dashboardDisabled: boolean;

  // User-configurable post-login landing route. When unset, the role default
  // (see role-landing.ts) is used. Validated against role permissions.
  preferences?: { defaultLandingPath?: string };

  // Timeclock + payroll Phase 1 fields. All optional, mirroring user.model.js
  // on the backend. Money is in cents.
  clockInPin?: string;
  photo?: string;
  employment?: {
    payType?: 'hourly' | 'salary' | 'tipped';
    exemptFromOvertime?: boolean;
    defaultJobRoleId?: string;
    scheduledStartGraceMinutes?: number;
  };
  jobRoles?: Array<{
    _id?: string;
    label: string;
    wageCents?: number;
    color?: string;
  }>;
}
